module.exports = __webpack_public_path__ + "img/gold_symbol_7.b5ccdbb6.png";